export default {
  not_set_up: {
    title: 'As reservas ainda não estão configuradas para esta localização',
    description:
      'Uma localização passa a ter reservas assim que é associada à sua ficha do Google e tem um proprietário. Se o restaurante ainda não tiver um proprietário, adicione um em Equipa. Até lá, não há horários de reservas para editar aqui, e as alterações ao horário da Loja Online não são copiadas para as Reservas.',
  },
  company_not_loaded: {
    title: 'Não foi possível carregar as definições de reservas',
    description:
      'Não foi possível carregar as definições de reservas deste local, pelo que o horário de funcionamento das reservas não pode ser editado neste momento. Tente novamente.',
    retry: 'Tentar novamente',
  },
};
